"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.showAlertFromNotification = exports.showExternalWebsite = exports.showWideAlertHtmlWithTextfieldsAndCheckbox = exports.showWideAlertHtmlWithTextfields = exports.showWideAlertHtmlWithTimeout = exports.showSysMessageAlertHtml = exports.showWideAlertHtml = exports.showWideAlertReact = exports.showAlertWithButtonsInNewLine = exports.showAlertInDebugMode = exports.showAlert = exports.showWideAlert = exports.showAlertWithoutButton = exports.showAlertWithAutomaticTimeout = exports.showAlertWithOptions = exports["default"] = exports.ALERT_TYPES = exports.SEVERITIES = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../targets/cord_sanofi/cssConstants.js"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _MuiAlertHelper = _interopRequireDefault(require("./MuiAlertHelper.scss"));

var _CordovaExternalWebsite = _interopRequireDefault(require("../common/components/CordovaExternalWebsite/CordovaExternalWebsite"));

var _ThemeStore = _interopRequireDefault(require("../common/components/ThemeStore/ThemeStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _TimeoutHelper = require("./TimeoutHelper");

var _StringHelper = _interopRequireDefault(require("./StringHelper"));

var _strings = require("../../config/strings");

var _BuildConstants = require("../utils/BuildConstants");

var _LogService = require("../KESI2/Services/LogService");

var _StoreComponent2 = _interopRequireDefault(require("../KESI2/Stores/StoreComponent"));

var _TCBackdrop = require("../common/components/DrupalTiles/TravelCare/TCBackdrop");

var _Select = _interopRequireDefault(require("@material-ui/core/Select/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var EXTRA_RENDERING_TIME = 50;
var listener = null;
var alerts = [];
var locked = false;
var SEVERITIES = {
  LOW: 50,
  NORMAL: 100,
  HIGH: 500
};
exports.SEVERITIES = SEVERITIES;
var ALERT_TYPES = {
  SYS_MESSAGE: 'sysMessage'
};
exports.ALERT_TYPES = ALERT_TYPES;

var MuiAlertHelper = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(MuiAlertHelper, _StoreComponent);

  var _super = _createSuper(MuiAlertHelper);

  function MuiAlertHelper(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, MuiAlertHelper);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          if (el.id.indexOf('actionBtn') > -1 || el.id.indexOf('closeBtn') > -1) {
            el.click();
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTextfieldChange", function (textfieldConfig) {
      return function (evt) {
        if (textfieldConfig.onChange) {
          textfieldConfig.onChange(evt);
        }

        textfieldConfig.value = evt.target.value;

        _this.forceUpdate();
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSelectChange", function (selectConfig) {
      return function (evt) {
        if (selectConfig.onChange) {
          selectConfig.onChange(evt);
        }

        selectConfig.value = evt.target.value;

        _this.forceUpdate();
      };
    });
    _this.state = {
      currentAlert: null
    };
    _this.focussedTextfields = 0;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(MuiAlertHelper.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar']
    }]);
    /**
     * Call the return function to close the alert.
     * Call the return function with 'true' parameter, to update the alert
     * @param alert
     * @returns {Function}
     */

    listener = function listener(alert) {
      alert.visible = true;
      alert.centeredContent = alert.centeredContent !== false;
      alert.severity = alert.severity || SEVERITIES.NORMAL;
      var newAlerts = alerts.slice();
      newAlerts.push(alert);
      newAlerts.sort(function (a, b) {
        if (a.severity < b.severity) {
          return 1;
        }

        if (a.severity > b.severity) {
          return -1;
        }

        return 0;
      });
      alerts = newAlerts;

      _this.showNextAlertIfAny(); // return a function to close or update this alert
      // if called with 'show', the callback triggers the rendering of the action button


      return function () {
        var updateInsteadOfClosing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (updateInsteadOfClosing) {
          if (updateInsteadOfClosing === 'showButtons') alert.hideButtons = false;
          console.log('update alert');

          _this.forceUpdate();

          return;
        }

        _this.removeAlert(alert);
      };
    };

    return _this;
  }

  (0, _createClass2["default"])(MuiAlertHelper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.showNextAlertIfAny();

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(MuiAlertHelper.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getCurrentAlert",
    value: function getCurrentAlert() {
      var skipCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (alerts.length <= skipCount) {
        return null;
      }

      return alerts[skipCount];
    }
  }, {
    key: "removeAlert",
    value: function () {
      var _removeAlert = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(alert) {
        var _this4 = this;

        var reallyRemoveAlertFromArray;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reallyRemoveAlertFromArray = function reallyRemoveAlertFromArray() {
                  var newAlerts = alerts.slice();
                  var index = newAlerts.indexOf(alert);

                  if (index !== -1) {
                    newAlerts.splice(index, 1);
                  }

                  alerts = newAlerts;
                };

                if (!(alert !== this.state.currentAlert)) {
                  _context.next = 4;
                  break;
                }

                reallyRemoveAlertFromArray();
                return _context.abrupt("return");

              case 4:
                if (!locked) {
                  _context.next = 8;
                  break;
                }

                console.log('can\'t remove dialog because change is locked. Trying again in 100ms');
                setTimeout(function () {
                  _this4.removeAlert(alert);
                }, 100);
                return _context.abrupt("return");

              case 8:
                locked = true; // the hiding transition is not nice if the keyboard is open and is very much nicer if the alert disappers then

                if (alert.textfields) {
                  _context.next = 14;
                  break;
                }

                // hide current alert
                alert.visible = false;
                this.forceUpdate();
                _context.next = 14;
                return (0, _TimeoutHelper.timeout)(500);

              case 14:
                reallyRemoveAlertFromArray();
                locked = false;
                this.showNextAlertIfAny();

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeAlert(_x) {
        return _removeAlert.apply(this, arguments);
      }

      return removeAlert;
    }()
  }, {
    key: "showNextAlertIfAny",
    value: function () {
      var _showNextAlertIfAny = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this5 = this;

        var alert, alertTimeout, timeoutCallback;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!locked) {
                  _context2.next = 3;
                  break;
                }

                console.log('can\'t show next alert because change is locked', alerts);
                return _context2.abrupt("return");

              case 3:
                if (!(alerts.length === 0)) {
                  _context2.next = 6;
                  break;
                }

                this.setState({
                  currentAlert: null
                });
                return _context2.abrupt("return");

              case 6:
                alert = alerts[0];
                this.setState({
                  currentAlert: alert
                });
                (0, _LogService.pushTravelAndCareLogMessage)('alert', {
                  title: alert.title,
                  message: alert.logMessage || alert.html || alert.message || (alert.react ? '[React alert without log message]' : '')
                }); // if a timeout was set, hide the alert after that time

                alertTimeout = alert.timeout || 0;

                if (alertTimeout > 0) {
                  timeoutCallback = alert.timeoutCallback || null;
                  setTimeout(function () {
                    _this5.removeAlert(alert);

                    if (timeoutCallback) {
                      timeoutCallback();
                    }
                  }, alertTimeout + EXTRA_RENDERING_TIME); // timeout + some extra rendering time
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showNextAlertIfAny() {
        return _showNextAlertIfAny.apply(this, arguments);
      }

      return showNextAlertIfAny;
    }()
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton(alert) {
      var _this6 = this;

      if (!alert) {
        console.warn('no alert given in renderCloseButton');
        return null;
      }

      if (alert.showCloseButton) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: "".concat(_MuiAlertHelper["default"].closeButton, " ").concat(alert.size === 'full' || alert.size === 'fullWithButtons' ? _MuiAlertHelper["default"].closeButtonExtraPadding : ''),
          theme: "close",
          onClick: alert.closeButtonFn ? alert.closeButtonFn : function () {
            _this6.removeAlert(alert);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var alert = this.state.currentAlert;

      if (!alert) {
        return null;
      }

      var title = alert.title;
      var message = alert.message;
      var messageReact = alert.react;
      var messageHtml = alert.html;
      var logMessage = alert.logMessage;
      var size = alert.size;
      var newLineButton = alert.newLineButton;
      var columnButtons = alert.columnButtons || false;
      var externalUrl = alert.externalUrl;
      var sendsMessages = alert.sendsMessages;
      var onLoadErrorExternal = alert.onLoadError;
      var contentExtraSmallPadding = alert.contentExtraSmallPadding || false;
      var type = alert.type;
      var hideButtons = alert.hideButtons || false;
      console.log('MuiAlertHelper', messageReact);
      var key = 0;
      var inputKey = 0;
      var buttons = alert.buttons ? alert.buttons.map(function (button) {
        var StyledButton = (0, _withStyles["default"])({
          root: button.classes && button.classes.root ? button.classes.root : {
            backgroundColor: _cssConstants["default"].colors && _cssConstants["default"].colors.buttonBackground ? _cssConstants["default"].colors.buttonBackground : null,
            color: _cssConstants["default"].colors && _cssConstants["default"].colors.buttonCaption ? _cssConstants["default"].colors.buttonCaption : null,
            '&:hover': {
              backgroundColor: _cssConstants["default"].colors && _cssConstants["default"].colors.buttonBackgroundHover ? _cssConstants["default"].colors.buttonBackgroundHover : null,
              color: _cssConstants["default"].colors && _cssConstants["default"].colors.buttonCaption ? _cssConstants["default"].colors.buttonCaption : null
            }
          }
        })(_Button["default"]);
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, button.title ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _MuiAlertHelper["default"].buttonTitle
        }, button.title) : null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
          key: key++,
          id: 'actionBtn',
          className: button.className || '',
          style: button.style ? button.style : {},
          disabled: button.enabledIf ? !button.enabledIf() : false,
          variant: button.variant || 'contained',
          isDefault: button.isDefault,
          role: 'button',
          "aria-label": button.ariaLabel ? button.ariaLabel : 'Dialog Button',
          onClick: function onClick() {
            (0, _LogService.pushTravelAndCareLogMessage)('alert_button_push', {
              title: title,
              message: logMessage || messageHtml || message || (messageReact ? '[React alert without log message]' : ''),
              chosenButton: button.label
            });

            if (button.remove || typeof button.remove === 'undefined') {
              _this7.removeAlert(alert);
            }

            if (button.callback) {
              button.callback();
            }
          }
        }, button.label));
      }) : null;
      var textfields = null;
      var error = null;
      var htmlError = null;
      var checkboxes = null;
      var selects = null;
      checkboxes = alert.checkboxes ? alert.checkboxes.map(function (box, index) {
        var StyledCheckbox = (0, _withStyles["default"])({
          root: box.classes && box.classes.icon ? box.classes.icon : box.className ? box.className : {
            color: _cssConstants["default"].colors && _cssConstants["default"].colors.buttonBackground ? _cssConstants["default"].colors.buttonBackground : null
          },
          checked: box.classes && box.classes.icon ? box.classes.icon : box.className ? box.className : {
            color: "".concat(_cssConstants["default"].colors && _cssConstants["default"].colors.buttonBackground ? _cssConstants["default"].colors.buttonBackground : null, " !important")
          }
        })(_Checkbox["default"]);
        console.log('checkbox', box.containerStyle);
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: box.containerStyle ? box.containerStyle : {},
          key: "box_".concat(index)
        }, box.additionalElement ? /*#__PURE__*/_react["default"].createElement("div", null, box.additionalElement) : null, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          control: /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
            color: 'primary',
            key: inputKey++,
            ref: box.ref,
            onChange: box.onChange,
            ripple: box.ripple,
            style: box.style || {},
            checked: box.checked ? box.checked() : false
          }),
          label: /*#__PURE__*/_react["default"].createElement("span", {
            onClick: box.onLabelClick ? function () {
              box.onLabelClick();
            } : function () {},
            style: {
              fontSize: '12px'
            },
            dangerouslySetInnerHTML: {
              __html: box.label
            }
          })
        }));
      }) : null;
      selects = alert.selects ? alert.selects.map(function (select, index) {
        console.log('got a select', select);
        return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
          key: "select_".concat(index),
          value: select.value,
          onChange: _this7.onSelectChange(select),
          displayEmpty: true,
          classes: select.classes,
          className: _MuiAlertHelper["default"].selectContainer,
          inputProps: select.inputProps
        }, select.title ? /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          value: "",
          disabled: true
        }, /*#__PURE__*/_react["default"].createElement("em", null, select.title)) : null, select.options.map(function (option, index2) {
          return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
            key: "option_".concat(index2),
            value: option.value
          }, option.text);
        }));
      }) : null;
      var textfieldDefaultValues = [];
      textfields = alert.textfields ? alert.textfields.map(function (textfield) {
        var onBlur = function onBlur() {
          _this7.focussedTextfields -= 1;

          if (alert.scrollToTopOnBlur && _DeviceInfoHelper["default"].isiOS()) {
            /**
             Fixes a bug where when we have 2 textfields and one loses focus because user clicked on the other one (onBlur),
             the alert moves weirdly due to the window.scrollTo. With the timeout we wait and check if another textfield has been focussed
             and do not scroll if so. Timeout of 0 is enough since it will move back in the execution queue this way (I think).
             */
            setTimeout(function () {
              if (_this7.focussedTextfields === 0) {
                window.scrollTo(0, 0);
              }
            }, 0);
          }

          if (textfield.onBlur) {
            textfield.onBlur.apply(textfield, arguments);
          }
        };

        var onFocus = function onFocus() {
          _this7.focussedTextfields += 1;

          if (textfield.onFocus) {
            textfield.onFocus.apply(textfield, arguments);
          }
        };

        if (textfield.defaultValue) {
          textfieldDefaultValues.push({
            id: textfield.id,
            defaultValue: textfield.defaultValue
          });
        }

        if (_DeviceInfoHelper["default"].isiOS()) {
          var _inputProps = textfield.type === 'number' ? {
            autoCapitalize: 'none',
            spellCheck: 'false',
            autoCorrect: 'off',
            onBlur: onBlur,
            onFocus: onFocus,
            min: '0',
            inputMode: 'numeric',
            pattern: '[0-9]*'
          } : {
            autoCapitalize: 'none',
            spellCheck: 'false',
            autoCorrect: 'off',
            onBlur: onBlur,
            onFocus: onFocus
          }; //          if (textfield.autofocus || (textfield.autoFocusScreensHigherThan && textfield.autoFocusScreensHigherThan <= window.screen.availHeight)) {


          if (textfield.autofocus || textfield.autoFocusScreensHigherThan && textfield.autoFocusScreensHigherThan <= window.innerHeight) {
            _inputProps.autoFocus = 'autofocus';
          }

          return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
            id: textfield.id,
            fullWidth: true,
            className: _MuiAlertHelper["default"].textfieldInput,
            inputRef: textfield.ref,
            autoComplete: "off",
            key: inputKey++,
            onChange: _this7.onTextfieldChange(textfield),
            type: textfield.type || 'text',
            label: textfield.label,
            rows: textfield.type === 'textarea' ? 5 : null,
            value: textfield.value,
            disabled: textfield.disabled || false,
            InputProps: textfield.InputProps,
            inputProps: _inputProps,
            required: textfield.required || false,
            multiline: textfield.multiline || false
          });
        }

        if (_DeviceInfoHelper["default"].isBrowser()) {
          textfield.onKeyPress = function (e) {
            // enter
            if (e.charCode === 13 && (0, _isArray["default"])(buttons)) {
              var defaultButton = buttons.find(function (b) {
                return b.props.isDefault;
              });

              if (defaultButton) {
                defaultButton.props.onClick();
              }
            }
          };
        }

        var inputProps = {
          autoCapitalize: 'none',
          spellCheck: 'false',
          autoCorrect: 'off'
        };

        if (textfield.ariaLabel) {
          inputProps['aria-label'] = textfield.ariaLabel;
        } //      if (textfield.autofocus || (textfield.autoFocusScreensHigherThan && textfield.autoFocusScreensHigherThan <= window.screen.availHeight)) {


        if (textfield.autofocus || textfield.autoFocusScreensHigherThan && textfield.autoFocusScreensHigherThan <= window.innerHeight) {
          inputProps.autoFocus = 'autofocus';
        }

        return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          id: textfield.id,
          fullWidth: true,
          className: _MuiAlertHelper["default"].textfieldInput,
          inputRef: textfield.ref,
          autoComplete: "off",
          key: inputKey++,
          onChange: _this7.onTextfieldChange(textfield),
          onFocus: textfield.onFocus,
          onBlur: textfield.onBlur,
          type: textfield.type || 'text',
          label: textfield.label,
          rows: textfield.type === 'textarea' ? 5 : null,
          value: textfield.value,
          disabled: textfield.disabled || false,
          InputProps: textfield.InputProps,
          inputProps: inputProps,
          required: textfield.required || false,
          multiline: textfield.multiline || false,
          onKeyPress: textfield.onKeyPress
        });
      }) : null;
      error = alert.error ? alert.error : null;
      htmlError = alert.htmlError ? alert.htmlError : null;
      setTimeout(function () {
        textfieldDefaultValues.forEach(function (idValue) {
          var element = document.getElementById(idValue.id);

          if (element) {
            element.value = idValue.defaultValue;
          }
        });
      }, 200);
      var titleStyle = {};

      if (type === ALERT_TYPES.SYS_MESSAGE) {
        if (_cssConstants["default"].colors.sysMessageTitleBackground) {
          titleStyle.backgroundColor = _cssConstants["default"].colors.sysMessageTitleBackground;
        }

        if (_cssConstants["default"].colors.sysMessageTitleColor) {
          titleStyle.color = _cssConstants["default"].colors.sysMessageTitleColor;
        }
      }

      var titleElement = title ? /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        disableTypography: true,
        style: titleStyle,
        className: alert.showCloseButton && alert.extraPaddingAroundCloseButton ? _MuiAlertHelper["default"].titlePadding : _MuiAlertHelper["default"].title
      }, title) : alert.extraPaddingAroundCloseButton ? /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
        disableTypography: true,
        style: titleStyle,
        className: _MuiAlertHelper["default"].noTitlePadding
      }) : null;
      var contentElement;

      if (message) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
          tabIndex: 0,
          className: "".concat(_MuiAlertHelper["default"].content, " ").concat(alert.theme ? _MuiAlertHelper["default"][alert.theme] : '', " ").concat(contentExtraSmallPadding ? _MuiAlertHelper["default"].contentSmallPadding : '', " ").concat(alert.centeredContent ? _MuiAlertHelper["default"].centered : '', " ").concat(alert.disableScrolling ? _MuiAlertHelper["default"].noScroll : '', " ").concat(alert.size === 'full' ? _MuiAlertHelper["default"].full : '', " ").concat(alert.size === 'fullWithButton' ? title ? _MuiAlertHelper["default"].fullWithButtons : _MuiAlertHelper["default"].fullWithButtonsNoTitle : '')
        }, message);
      } else if (messageHtml) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
          tabIndex: 0,
          className: "".concat(_MuiAlertHelper["default"].content, " ").concat(alert.theme ? _MuiAlertHelper["default"][alert.theme] : '', " ").concat(contentExtraSmallPadding ? _MuiAlertHelper["default"].contentSmallPadding : '', " ").concat(alert.centeredContent ? _MuiAlertHelper["default"].centered : '', " ").concat(alert.disableScrolling ? _MuiAlertHelper["default"].noScroll : '', " ").concat(alert.size === 'full' ? _MuiAlertHelper["default"].full : '', " ").concat(alert.size === 'fullWithButton' ? title ? _MuiAlertHelper["default"].fullWithButtons : _MuiAlertHelper["default"].fullWithButtonsNoTitle : ''),
          dangerouslySetInnerHTML: {
            __html: messageHtml
          }
        });
      } else if (messageReact) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
          tabIndex: 0,
          className: "".concat(_MuiAlertHelper["default"].content, " ").concat(alert.theme ? _MuiAlertHelper["default"][alert.theme] : '', " ").concat(contentExtraSmallPadding ? _MuiAlertHelper["default"].contentSmallPadding : '', " ").concat(alert.centeredContent ? _MuiAlertHelper["default"].centered : '', " ").concat(alert.disableScrolling ? _MuiAlertHelper["default"].noScroll : '', "  ").concat(alert.size === 'full' ? _MuiAlertHelper["default"].full : '', " ").concat(alert.size === 'fullWithButton' ? title ? _MuiAlertHelper["default"].fullWithButtons : _MuiAlertHelper["default"].fullWithButtonsNoTitle : '')
        }, messageReact);
      } else if (externalUrl) {
        contentElement = /*#__PURE__*/_react["default"].createElement(_CordovaExternalWebsite["default"], {
          url: externalUrl,
          sendsMessages: sendsMessages,
          onLoadErrorBeforeAlert: function onLoadErrorBeforeAlert() {
            return _this7.removeAlert(alert);
          },
          onLoadError: onLoadErrorExternal,
          closeFunc: function closeFunc() {
            return _this7.removeAlert(alert);
          },
          closeAndRetryFunc: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this7.removeAlert(alert);

                    _context3.next = 3;
                    return (0, _TimeoutHelper.timeout)(400);

                  case 3:
                    alert.onRetry();

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))
        });
      }

      var errorElement = null;

      if (error) {
        errorElement = /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
          className: _MuiAlertHelper["default"].error
        }, error);
      } else if (htmlError) {
        errorElement = /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
          className: _MuiAlertHelper["default"].error,
          dangerouslySetInnerHTML: {
            __html: htmlError
          }
        });
      } // const checkElement = checkboxes
      //   ?
      //   <DialogActions classes={{action: s.action, button: s.textfield}}>{checkboxes}</DialogActions>
      //   : null


      var image = alert.image ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _MuiAlertHelper["default"].titleImage,
        src: alert.image,
        alt: 'Logo'
      }) : null;
      var selectElement = selects ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _MuiAlertHelper["default"].select
      }, selects) : null;
      var checkElement = checkboxes ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: 'calc(100% - 28px)',
          textAlign: 'left',
          marginLeft: 14
        }
      }, checkboxes) : null;
      var inputElement = textfields ? /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
        className: _MuiAlertHelper["default"].root
      }, textfields) : null;
      var actionsElementStyle = _config["default"].isSafetureApp ? _MuiAlertHelper["default"].buttonActionsERV : _MuiAlertHelper["default"].buttonActions;

      if (newLineButton) {
        actionsElementStyle += " ".concat(_MuiAlertHelper["default"].fullWidthInput);
      }

      if (columnButtons) {
        actionsElementStyle += " ".concat(_MuiAlertHelper["default"].columnButtons);
      }

      if (alert.buttons && alert.buttons.length > 0) {
        alert.buttons.forEach(function (button) {
          if (button.theme === 'pwReset') {
            actionsElementStyle += " ".concat(_MuiAlertHelper["default"].extraPadding);
          }

          if (button.theme === 'welcome') {
            actionsElementStyle += " ".concat(_MuiAlertHelper["default"].welcomeButton);
          }

          if (button.theme === 'big') {
            actionsElementStyle += " ".concat(_MuiAlertHelper["default"].bigButton);
          }
        });
      }

      var actionsElement = buttons && !hideButtons && buttons.length > 0 ? /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
        className: actionsElementStyle
      }, buttons) : null;
      var className = _MuiAlertHelper["default"].paper;

      if (alert.size === 'wide' || alert.size === 'large') {
        className = _MuiAlertHelper["default"].widePaper;
      } else if (alert.size === 'full' || alert.size === 'fullWithButton') {
        className = _MuiAlertHelper["default"].fullScreen;
      }

      var div = /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
        open: alert.visible,
        classes: {
          root: selects ? _MuiAlertHelper["default"].dialogWithSelects : _MuiAlertHelper["default"].dialog,
          paper: className
        },
        PaperProps: {
          id: alert.id ? alert.id : _StringHelper["default"].createShortId(),
          style: alert.style ? alert.style : {}
        },
        BackdropComponent: _TCBackdrop.TCBackdrop
      }, this.renderCloseButton(alert), titleElement, image, contentElement, errorElement, inputElement, selectElement, checkElement, actionsElement);

      return div;
    }
  }]);
  return MuiAlertHelper;
}(_StoreComponent2["default"]);
/**
 * Call the return function to close the alert.
 * Call the return function with 'true' parameter, to update the alert
 * @param alert
 * @returns {Function}
 */


exports["default"] = MuiAlertHelper;

var showAlertWithOptions = function showAlertWithOptions(alert) {
  if (alert.debugModeOnly) {
    if (_BuildConstants.NODE_ENV === 'production') {
      return function () {}; // return stub function
    }
  }

  var alertToUse = (0, _assign["default"])({
    message: null,
    html: null,
    react: null,
    logMessage: null,
    title: null,
    severity: SEVERITIES.NORMAL,
    size: 'small',
    showCloseButton: true,
    closeButtonFn: null,
    extraPaddingAroundCloseButton: true,
    // if true, the close button is rendered on its own line, otherwise same line like title
    buttons: [{
      label: (0, _strings.getString)('OK'),
      variant: 'text'
    }],
    // see material ui homepage for more variants
    contentExtraSmallPadding: false,
    debugModeOnly: false,
    centeredContent: true,
    theme: null,
    style: null,
    columnButtons: false
  }, alert);

  if (alert.debugModeOnly) {
    alertToUse.title = "[DEBUG] ".concat(alertToUse.title);
  }

  if (listener) {
    return listener(alertToUse);
  } // if listener not yet present due to early show of the alert
  // there is no return value. Sorry for that.


  setTimeout(function () {
    showAlertWithOptions(alert);
  }, 300);
  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithOptions = showAlertWithOptions;

var showAlertWithAutomaticTimeout = function showAlertWithAutomaticTimeout(message, title, timeout, timeoutCallback) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var buttons = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var copyButtons = [].concat(buttons);

  if (listener) {
    return listener({
      message: message,
      title: title,
      buttons: copyButtons,
      timeout: timeout,
      timeoutCallback: timeoutCallback,
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithAutomaticTimeout = showAlertWithAutomaticTimeout;

var showAlertWithoutButton = function showAlertWithoutButton(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isWideAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (listener) {
    return listener({
      message: message,
      title: title,
      size: isWideAlert ? 'large' : 'small',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithoutButton = showAlertWithoutButton;

var showWideAlert = function showWideAlert(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isWideAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var buttons = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      message: message,
      title: title,
      buttons: copyButtons,
      size: isWideAlert ? 'large' : 'small',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlert = showWideAlert;

var showAlert = function showAlert(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 ? arguments[3] : undefined;
  return showWideAlert(message, title, showCloseButton, false, buttons);
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlert = showAlert;

var showAlertInDebugMode = function showAlertInDebugMode(message, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (_BuildConstants.NODE_ENV !== 'production') {
    if (listener) {
      var copyButtons = [].concat(buttons);

      if (copyButtons.length === 0) {
        // add a default button
        copyButtons.push({
          label: 'OK',
          callback: function callback() {}
        });
      }

      return listener({
        message: "[DEBUG] ".concat(message),
        title: title,
        buttons: copyButtons,
        showCloseButton: showCloseButton
      });
    }
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertInDebugMode = showAlertInDebugMode;

var showAlertWithButtonsInNewLine = function showAlertWithButtonsInNewLine(htmlMessage, title, newLineButton) {
  var showCloseButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var buttons = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      newLineButton: newLineButton,
      buttons: copyButtons,
      size: 'large',
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showAlertWithButtonsInNewLine = showAlertWithButtonsInNewLine;

var showWideAlertReact = function showWideAlertReact(reactMessage, logMessage, title) {
  var showCloseButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var buttons = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var centeredContent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var checkboxes = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var selects = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      react: reactMessage,
      logMessage: logMessage,
      title: title,
      checkboxes: checkboxes,
      selects: selects,
      buttons: copyButtons,
      showCloseButton: showCloseButton,
      centeredContent: centeredContent
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertReact = showWideAlertReact;

var showWideAlertHtml = function showWideAlertHtml(htmlMessage, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var centeredContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var checkboxes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      checkboxes: checkboxes,
      buttons: copyButtons,
      showCloseButton: showCloseButton,
      centeredContent: centeredContent
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtml = showWideAlertHtml;

var showSysMessageAlertHtml = function showSysMessageAlertHtml(htmlMessage, title) {
  var showCloseButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var buttons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var centeredContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var checkboxes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);

    if (copyButtons.length === 0) {
      // add a default button
      copyButtons.push({
        label: 'OK',
        callback: function callback() {}
      });
    }

    return listener({
      html: htmlMessage,
      title: title,
      checkboxes: checkboxes,
      buttons: copyButtons,
      showCloseButton: showCloseButton,
      centeredContent: centeredContent,
      size: 'wide',
      type: ALERT_TYPES.SYS_MESSAGE
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showSysMessageAlertHtml = showSysMessageAlertHtml;

var showWideAlertHtmlWithTimeout = function showWideAlertHtmlWithTimeout(htmlMessage, title, timeout, timeoutCallback) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var buttons = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      buttons: copyButtons,
      size: 'large',
      timeout: timeout,
      timeoutCallback: timeoutCallback,
      showCloseButton: showCloseButton
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead
 * @param htmlMessage
 * @param title
 * @param htmlError
 * @param textfields
 * @param showCloseButton
 * @param effect
 * @param buttons
 * @param scrollToTopOnBlur -- ONLY ON IOS -- fixes a bug in iOS 12 when build with Xcode 10 when hiding the keyboard is not fully working.
 * @returns {*}
 */


exports.showWideAlertHtmlWithTimeout = showWideAlertHtmlWithTimeout;

var showWideAlertHtmlWithTextfields = function showWideAlertHtmlWithTextfields(htmlMessage, title, htmlError) {
  var textfields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{
    label: '',
    type: 'text',
    onChange: function onChange() {},
    ref: 'customId',
    className: ''
  }];
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var effect = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var buttons = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var scrollToTopOnBlur = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      htmlError: htmlError,
      effect: effect,
      textfields: textfields,
      buttons: copyButtons,
      showCloseButton: showCloseButton,
      scrollToTopOnBlur: scrollToTopOnBlur
    });
  }
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtmlWithTextfields = showWideAlertHtmlWithTextfields;

var showWideAlertHtmlWithTextfieldsAndCheckbox = function showWideAlertHtmlWithTextfieldsAndCheckbox(htmlMessage, title, htmlError) {
  var textfields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{
    label: '',
    type: 'text',
    onChange: function onChange() {},
    ref: 'customId',
    className: ''
  }];
  var checkboxes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [{
    checked: false,
    label: '',
    onChange: function onChange() {},
    ref: 'customId',
    className: '',
    ripple: true
  }];
  var showCloseButton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var effect = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var buttons = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var scrollToTopOnBlur = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;

  if (listener) {
    var copyButtons = [].concat(buttons);
    return listener({
      html: htmlMessage,
      title: title,
      htmlError: htmlError,
      effect: effect,
      textfields: textfields,
      checkboxes: checkboxes,
      buttons: copyButtons,
      showCloseButton: showCloseButton,
      scrollToTopOnBlur: scrollToTopOnBlur
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showWideAlertHtmlWithTextfieldsAndCheckbox = showWideAlertHtmlWithTextfieldsAndCheckbox;

var showExternalWebsite = function showExternalWebsite(url, onError, sendsMessages, onRetry) {
  var showCloseButton = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  if (listener) {
    return listener({
      externalUrl: url,
      sendsMessages: sendsMessages,
      onLoadError: onError,
      showCloseButton: showCloseButton,
      onRetry: onRetry,
      size: 'fullscreen'
    });
  }

  return null;
};
/**
 *
 * @deprecated Please use MuiAlertHelper.showAlertWithOptions instead.
 */


exports.showExternalWebsite = showExternalWebsite;

var showAlertFromNotification = function showAlertFromNotification(message) {
  if (message.name === 'alert') {
    try {
      var data = JSON.parse(message.data);
      var title = data.title || (0, _strings.getString)('NOTIFICATION');
      var content = data.html;

      if (!content || content.trim().length === 0) {
        console.warn('did receive remote ably message, but html was empty', content);
      } else {
        showWideAlertHtml(content, title);
      }

      return true;
    } catch (error) {
      console.warn('did receive remote ably message, but an error occurred', message, error);
      return true;
    }
  }

  return false;
};

exports.showAlertFromNotification = showAlertFromNotification;